var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('billing-edit-template',{attrs:{"originalBilling":_vm.originalBilling,"memberName":_vm.billedUser.name},on:{"cancel":_vm.cancel,"submit":_vm.submit}})}
var staticRenderFns = []

export { render, staticRenderFns }